import React, { useEffect, useState } from 'react';
import { Components } from 'ck-shared';
import Loading from '../../shared/Loading';
import useRouteStatus from '../../../hooks/useRouteStatus';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { asyncActions, clearErrors, toggleRethrow } from '../../../actions/general';
import { formatPhoneNumber } from '../../../lib/formatters';
import { getUser } from '../../../actions/users';
import { loading, getRoute } from '../../../actions/sessions';
import { updateApplication } from '../../../actions/applications';
import { useDispatch, useSelector } from 'react-redux';

export default function PhoneVerification({ location }) {
  const dispatch = useDispatch();
  const user = useSessionEntity('user');
  const application = useSessionEntity('application');
  const errors = useSelector(state => state.general.get('errors'));
  const rethrow = useSelector(state => state.general.get('rethrow'));
  const isLoading = useSelector(state => state.sessions.get('loading'));
  const [ updatingPhone, setUpdatingPhone ] = useState(false);
  const [ bodyText, setBodyText ] = useState();

  const standardConfirmText =
    <>
      <div className="is-size-4 has-text-weight-semibold">
        Please confirm your mobile number
      </div>

      We'll text a 6-digit code to your phone
    </>;

  const updatePhoneText =
    <>
      <div className="is-size-4 has-text-weight-semibold mb-4">
        We're unfortunately unable to find an association between

        <div>
          {formatPhoneNumber(user.phone)} and your name.
        </div>
      </div>

      <div>
        Please double-check the number.
      </div>

      It must be a mobile number with your name on the account.

      <div>
        You can update the number below.
      </div>
    </>;

  const foundPhoneError = () => errors.count() > 0 && errors.first() && errors.first().match(/phone/i);

  const updateUserPhone = phone => {
    if (phone) {
      dispatch(toggleRethrow());

      return dispatch(asyncActions(
        updateApplication(application.set('phone', phone)),
        getUser(user.id)
      ))
      .then(() => (rethrow && dispatch(toggleRethrow())) && dispatch(clearErrors()))
    } else {
      return new Promise((resolve, reject) => resolve());
    }
  };

  useEffect(() => {
    setUpdatingPhone(application.reasons.includes('cognito_phone_fail'));
  }, []);

  useEffect(() => {
    setBodyText(updatingPhone ? updatePhoneText : standardConfirmText);
  }, [updatingPhone]);

  useEffect(() => {
    dispatch(loading(true));

    if (bodyText) dispatch(loading(false));
  }, [bodyText]);

  useRouteStatus(location);

  if (!bodyText) return (<Loading active={true} />);

  return (
    <div id="content">
      <div className="columns is-centered">
        <div className="column has-text-centered">
          {bodyText}
        </div>
      </div>

      {foundPhoneError() &&
        <div className="notification is-danger is-light has-text-centered mt-4">
          That phone number is already in use
        </div>}

      <Components.UserVerification
        defaultValue={user.phone}
        icon={false}
        onSuccessPath='verify'
        onLoading={loading}
        isLoading={isLoading}
        onSideEffect={updateUserPhone}
        onSubmit={getRoute}
        buttonText={updatingPhone ? "Confirm" : "Next"}
      />

    </div>
  )
}
